import { Skeleton } from '@app/components/various/Skeleton';
import { MatrixSkeleton } from '@app/components/various/SkeletonLayout/layouts/MatrixSkeleton';
import { getDefaultImageAspectRatio } from '@app/ducks/helpers';
import { useSelector } from 'react-redux';

const MAX_NUMBER_OF_ATTRIBUTES = 6;

export const OrderProductSkeleton = () => {
  const imageAspectRatio = useSelector(getDefaultImageAspectRatio);

  return (
    <>
      <div className="mx-auto my-5 hidden rounded-regular bg-white p-4 sm:block lg:px-8 lg:py-5">
        <div className="flex flex-col gap-3 gap-x-8 overflow-hidden">
          <div className="flex flex-col gap-x-8 gap-y-6 sm:flex-row">
            <div className="row-span-2 size-full w-40 shrink-0 sm:w-32">
              <Skeleton type="rectangle" aspectRatio={imageAspectRatio} />
            </div>
            <div className="flex grow flex-col">
              <div className="flex justify-between gap-8">
                <div className="flex flex-1 flex-col justify-between gap-6 lg:mb-3 lg:flex-row lg:gap-4">
                  <div className="h-14 w-full">
                    <div className="mb-2 max-w-72">
                      <Skeleton type="text" size="large" />
                    </div>
                    <div className="max-w-36">
                      <Skeleton type="text" size="small" />
                    </div>
                  </div>
                </div>
                <div className="mb-8 flex gap-x-5">
                  <Skeleton type="rectangle" className="size-14" />
                  <Skeleton type="rectangle" className="size-14" />
                  <Skeleton type="rectangle" className="size-14" />
                </div>
              </div>
              <div className="columns-3xs gap-10 pb-3">
                <Skeleton
                  type="text"
                  rows={MAX_NUMBER_OF_ATTRIBUTES}
                  size="xsmall"
                  width={80}
                  itemClassName="break-inside-avoid-column my-1.5"
                />
              </div>
              <div className="flex items-center">
                <div className="mb-2 min-w-56">
                  <Skeleton type="button" size="medium" />
                </div>
              </div>
              <div className="flex justify-end">
                <div className="w-full max-w-64">
                  <Skeleton type="button" size="large" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-hidden">
          <MatrixSkeleton />
        </div>
      </div>
      <div className="mx-auto my-5 rounded-regular bg-white p-4 sm:hidden lg:px-8 lg:py-5">
        <div className="flex flex-col gap-3 gap-x-8 overflow-hidden">
          <div className="flex flex-row gap-x-8 gap-y-6">
            <div className="row-span-2 size-full w-32 shrink-0 sm:w-32">
              <Skeleton type="rectangle" aspectRatio={imageAspectRatio} />
            </div>
            <div className="flex grow flex-col justify-between gap-8">
              <div className="flex justify-between gap-8">
                <div className="flex flex-1 flex-col justify-between gap-6 lg:mb-3 lg:flex-row lg:gap-4">
                  <div className="flex gap-8">
                    <div className="h-14 w-full">
                      <div className="mb-2 max-w-72">
                        <Skeleton type="text" size="large" />
                      </div>
                      <div className="max-w-36">
                        <Skeleton type="text" size="small" />
                      </div>
                    </div>
                    <div className="max-w-8">
                      <Skeleton type="rectangle" className="size-8" />
                    </div>
                  </div>
                  <Skeleton type="text" rows={3} size="xsmall" width={80} itemClassName="break-inside-avoid-column my-1.5" />
                </div>
              </div>
            </div>
          </div>
          <div className="columns-3xs gap-10 pb-3">
            <Skeleton
              type="text"
              rows={MAX_NUMBER_OF_ATTRIBUTES}
              size="xsmall"
              width={80}
              itemClassName="break-inside-avoid-column my-1.5"
            />
          </div>
          <div className="flex justify-end">
            <div className="w-full max-w-64">
              <Skeleton type="button" size="large" />
            </div>
          </div>
        </div>
        <div className="overflow-hidden">
          <MatrixSkeleton />
        </div>
      </div>
    </>
  );
};
